import { Edit, useForm } from '@refinedev/antd';
import { useGo } from '@refinedev/core';
import { message } from 'antd';
import { useEffect, useState } from 'react';

import { PackageItem } from '@/model/Logistic/PackageItem/PackageItem';
import { PACKAGE_STATES } from '@/model/Logistic/PackageStates';
import { Shipment } from '@/model/Logistic/Shipment/Shipment';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';
import { RESOURCES } from '@/Resources';

import ShipmentForm from './ShipmentForm/ShipmentForm';

export const ShipmentEdit = () => {
  const go = useGo();
  const { packageItemRepository } = useRepositoriesContext();
  const [saveAddress, setSaveAddress] = useState(false);
  const [packageItems, setPackageItems] = useState<PackageItem[]>([]);
  const { formProps, saveButtonProps, query } = useForm<Shipment>({
    redirect: false,
    successNotification: {
      message: 'Envío actualizado correctamente',
      type: 'success',
    },
    onMutationSuccess(shipmentResponse) {
      void packageItemRepository
        .savePackageItems(packageItems, shipmentResponse.data.id)
        .then(() => {
          go({
            to: { resource: RESOURCES.SHIPMENTS, action: 'show', id: shipmentResponse.data.id },
            type: 'replace',
          });
        })
        .catch(error => {
          message.error('Ocurrió un error al guardar los items del envío.');
          console.error('Error saving package items:', error);
        });
    },
  });

  useEffect(() => {
    if (formProps?.initialValues?.id && formProps?.initialValues?.status) {
      if (formProps?.initialValues?.status != PACKAGE_STATES.PENDIENTE) {
        message.error('No se pueden editar los envíos que no están en estado PENDIENTE');
        go({
          to: {
            resource: RESOURCES.SHIPMENTS,
            action: 'show',
            id: formProps?.initialValues?.id ?? '',
          },
          type: 'replace',
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formProps?.initialValues?.id]);

  return (
    <Edit saveButtonProps={saveButtonProps} isLoading={query?.isLoading || query?.isFetching}>
      {query?.data && (
        <ShipmentForm
          formProps={formProps}
          edit
          saveAddress={saveAddress}
          setSaveAddress={setSaveAddress}
          packageItems={packageItems}
          setPackageItems={setPackageItems}
        />
      )}
    </Edit>
  );
};
